// NPM MODULES
import React, { useCallback, useState, useEffect } from 'react';
import { Box, Button, Stack, FormControlLabel, Checkbox } from '@mui/material';

// COMPONENTS
import CustomerReportsTable from '../../components/reports/customer/CustomerReportsTable';
import CustomerReportsTableRow from '../../components/reports/customer/CustomerReportsTableRow';
import CustomerSingleView from '../../components/reports/customer/CustomerSingleView';
import DateRangeSelector from '../../components/common/DateRangeSelector';
import DataExportModal from '../../components/common/modals/DataExportModal';
import Layout from '../../components/layouts/Layout';
import Loader from '../../components/common/Loader';

// NETWORKING
import useCustomerReportsRequest from '../../requests/CustomerReportsRequest';

// FORMATTED MESSAGES
import CustomerReportsFormattedMessages from '../../messages/reports/CustomerReportsFormattedMessages';
import { ReportsRoutes } from '../../routes/ReportsRoutes';

const CustomerReport = ({
  customer,
  customerData,
  errorHandler,
  accessLevel,
  accessType,
}) => {
  const [smsList, setSmsList] = useState(null);
  const [data, setData] = useState([]);
  const [activeCustomers, setActiveCustomers] = useState([]);
  const [allCustomers, setAllCustomers] = useState([]);
  const [dataExists, setDataExists] = useState(false);
  const [totals, setTotals] = useState({
    Direct: 0,
    Standard: 0,
    Replies: 0,
    Sent: 0,
    Pending: 0,
    DirectParts: 0,
    StandardParts: 0,
    RepliesParts: 0,
    SentParts: 0,
    PendingParts: 0,
    Users: 0,
  });
  const [selectedData, setSelectedData] = useState(null);
  const [activePage, setActivePage] = useState('list');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [timeRange, setTimeRange] = useState(null);
  const [displayLetters, setDisplayLetters] = useState([]);
  const [filterLetter, setFilterLetter] = useState('');
  const [showAll, setShowAll] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [showEmailSentModal, setShowEmailSentModal] = useState(false);
  const [emailRecipient, setEmailRecipient] = useState('');
  const { getReportData, exportCustomerReport } = useCustomerReportsRequest();
  const [loading, setLoading] = useState(true);
  const [pageTitle, setPageTitle] = useState(
    CustomerReportsFormattedMessages.customerReportsTitle
  );

  useEffect(() => {
    if (customer && customer !== null) {
      console.log('Have props customerData?', customerData);
      if (customerData && customerData.length > 0) {
        console.log('Should not be here');
        setData(customerData);
        setDataExists(true);
        formatData(customerData);
      }
    }
  }, [customer, customerData]);

  const sortList = (data) => {
    return data.slice().sort((a, b) => {
      if (a.customer_name < b.customer_name) return -1;
      if (a.customer_name > b.customer_name) return 1;
      return 0;
    });
  };

  const formatData = (data) => {
    try {
      let total = {
        Direct: 0,
        Standard: 0,
        Replies: 0,
        Sent: 0,
        Pending: 0,
        DirectParts: 0,
        StandardParts: 0,
        RepliesParts: 0,
        SentParts: 0,
        PendingParts: 0,
        Users: 0,
      };
      let letterMap = {};
      let letters = [];

      const cleanedData = data
        .filter((el) => {
          if (
            displayLetters.length === 0 &&
            !letterMap[el.customer_name.toUpperCase().charAt(0)]
          ) {
            letterMap[el.customer_name.toUpperCase().charAt(0)] = true;
            letters.push(`${el.customer_name.toUpperCase().charAt(0)}`);
          }

          if (
            filterLetter === '' ||
            filterLetter.toLowerCase() ===
              el.customer_name.charAt(0).toLowerCase()
          ) {
            return true;
          }
        })
        .map((el) => (
          <CustomerReportsTableRow
            key={'key_' + el.customer_id}
            id={0}
            name={el.customer_name}
            active={el.customer_status_name}
            type={el.customer_type_name}
            customerClass={el.customer_class_name}
            userCount={el.userCount}
            Direct={{
              sent: el.direct_sent,
              parts: el.direct_parts,
              // onClick: () => changePage('svDir', el.customer_id),
            }}
            Standard={{
              sent: el.messages_sent,
              parts: el.messages_parts,
              // onClick: () => changePage('svStand', el.customer_id),
            }}
            Replies={{
              sent: el.replies_sent,
              parts: el.replies_parts,
              // onClick: () => changePage('svRep', el.customer_id),
            }}
            Sent={{
              sent: el.reminders_sent,
              parts: el.reminders_parts,
              // onClick: () => changePage('svSent', el.customer_id),
            }}
            Pending={{
              sent: el.reminders_pending,
              parts: el.reminders_pending_parts,
              // onClick: () => changePage('svPend', el.customer_id),
            }}
            onClickName={() => changePage('svCustomer', el.customer_id)}
          />
        ));

      data.forEach((el) => {
        if (
          filterLetter === '' ||
          filterLetter.toLowerCase() ===
            el.customer_name.charAt(0).toLowerCase()
        ) {
          total.Direct = total.Direct + parseInt(el.direct_sent);
          total.Standard = total.Standard + parseInt(el.messages_sent);
          total.Replies = total.Replies + parseInt(el.replies_sent);
          total.Sent = total.Sent + parseInt(el.reminders_sent);
          total.Pending = total.Pending + parseInt(el.reminders_pending);
          total.DirectParts = total.DirectParts + parseInt(el.direct_parts);
          total.StandardParts =
            total.StandardParts + parseInt(el.messages_parts);
          total.RepliesParts = total.RepliesParts + parseInt(el.replies_parts);
          total.SentParts = total.SentParts + parseInt(el.reminders_parts);
          total.PendingParts =
            total.PendingParts + parseInt(el.reminders_pending_parts);
          total.Users = total.Users + parseInt(el.userCount);
        }
      });

      console.log(letters);
      if (letters.length > 0) {
        letters.sort();
        setDisplayLetters(letters);
      }
      setSmsList(cleanedData);
      setTotals(total);
      setLoading(false);
    } catch (e) {
      console.log('data error:', e);
      setLoading(false);
    }
  };

  const backButton = () => {
    setActivePage('list');
    setPageTitle(CustomerReportsFormattedMessages.customerReportsTitle);
  };

  useEffect(() => {
    formatData(data);
  }, [filterLetter]);

  const handleLetterFilter = async (letter) => {
    setFilterLetter((state) => (state !== letter ? letter : ''));
  };

  const handleUserDataSearch = useCallback(async () => {
    setDataExists(false);
    setLoading(true);
    setData([]);
    setActiveCustomers([]);
    setAllCustomers([]);

    const searchParams = {
      fromDate: fromDate,
      toDate: toDate,
      timeRangeStart: fromDate,
      timeRangeEnd: toDate,
      timeRange: timeRange,
    };
    console.log('searchParams', searchParams);

    const result = await getReportData(searchParams, errorHandler);
    let data;
    if (showAll) {
      data = result.finalResults;
    } else {
      data = result?.activeResults;
    }

    setDataExists(true);
    setData(data);
    setActiveCustomers(result.activeResults);
    setAllCustomers(result.finalResults);
    setTimeRange(timeRange);
    formatData(data);
  }, [fromDate, toDate]);

  const handleExportCustomerReport = async () => {
    setExporting(true);
    const searchParams = {
      fromDate: fromDate,
      toDate: toDate,
    };

    const response = await exportCustomerReport(searchParams, errorHandler);
    console.log('response', response);
    setShowEmailSentModal(true);
    setEmailRecipient(response);
    setExporting(false);
  };

  useEffect(() => {
    if (fromDate && toDate) handleUserDataSearch();
  }, [handleUserDataSearch]);

  const changePage = (page, value) => {
    console.log(page);
    setActivePage(page);
    setSelectedData(value);
  };

  const generateSearchTools = () => {
    return (
      <Box sx={{ marginBottom: { xs: 4, md: 2 } }}>
        <DateRangeSelector
          handleDateSearch={() => handleUserDataSearch()}
          parentStartDate={fromDate}
          setParentStartDate={setFromDate}
          parentEndDate={toDate}
          setParentEndDate={setToDate}
        />
      </Box>
    );
  };

  const handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    console.log('handleInputChange event name:', name);
    console.log('handleInputChange event value:', value);

    if (name === 'showAll' && dataExists) {
      if (value === false) {
        console.log('activeCustomers', activeCustomers);
        setData(activeCustomers);
        formatData(activeCustomers);
      } else {
        setData(allCustomers);
        formatData(allCustomers);
      }
    }

    if (name === 'showAll') {
      setShowAll(value);
    }
  };

  const generateFirstLetterFilter = () => {
    if (customerData) return null;

    if (displayLetters !== undefined && displayLetters !== 'undefined') {
      const letterHtml = (displayLetters || []).map((letter) => {
        return (
          <Button
            key={letter}
            variant={'text'}
            onClick={() => handleLetterFilter(letter)}
            size="small"
            sx={{
              minWidth: 'auto',
              padding: 0.25,
              color:
                filterLetter === letter ? 'primary.main' : 'secondary.light',
            }}
          >
            {letter}
          </Button>
        );
      });

      return (
        <Stack
          sx={{
            flexDirection: { xs: 'column-reverse', md: 'row' },
            justifyContent: 'space-between',
            alignItems: { md: 'end' },
            width: '100%',
          }}
        >
          <Stack direction="row" sx={{ marginBottom: 0.25 }}>
            {letterHtml}
          </Stack>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 2,
              marginBottom: 2,
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  name="showAll"
                  checked={showAll}
                  onChange={(e) => handleInputChange(e)}
                  sx={{ padding: 0.45 }}
                />
              }
              label={'Show All'}
              sx={{ margin: 0 }}
            />
            <Button
              variant="contained"
              color="secondary"
              onClick={handleExportCustomerReport}
              disabled={exporting}
            >
              Email Report
            </Button>
          </Box>
        </Stack>
      );
    }
    return null;
  };

  return accessLevel === '3' && accessType === '3' ? (
    <Layout
      routes={ReportsRoutes}
      title={pageTitle}
      accessLevel={accessLevel}
      accessType={accessType}
      backButtonText={
        activePage === 'svCustomer'
          ? CustomerReportsFormattedMessages.backText
          : null
      }
      handleBackButton={activePage === 'svCustomer' ? backButton : null}
    >
      {activePage === 'svCustomer' ? (
        <CustomerSingleView
          accessLevel={accessLevel}
          accessType={accessType}
          customerId={selectedData}
          setPageTitle={setPageTitle}
          errorHandler={errorHandler}
        />
      ) : (
        <>
          {generateSearchTools()}
          {loading ? (
            <Loader />
          ) : (
            <>
              {generateFirstLetterFilter()}
              <CustomerReportsTable
                changePage={changePage}
                totals={totals}
                list={smsList}
                displayLetters={displayLetters}
              />
            </>
          )}
          <DataExportModal
            show={showEmailSentModal}
            onHide={() => setShowEmailSentModal(false)}
            emailRecipient={emailRecipient}
          />
        </>
      )}
    </Layout>
  ) : null;
};

export default CustomerReport;
